<template>
	<section class="section">
		<div class="container-fluid">
			<card ref="card" title="" icon="">
				<form-field label="表示開始日" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded date-picker-wrap">
							<date-picker :dateProvided="startDate" @input="onStartDateInput"></date-picker>
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('startDate')">{{ errors.startDate }}</p>
					</div>
				</form-field>

				<form-field label="表示終了日" sub="" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded date-picker-wrap">
							<date-picker :dateProvided="endDate" @input="onEndDateInput"></date-picker>
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('endDate')">{{ errors.endDate }}</p>
					</div>
				</form-field>

				<form-field label="内容" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" type="text" v-model="body">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('body')">{{ errors.body }}</p>
					</div>
				</form-field>

				<form-field :has-wrap="false">
					<div class="edit-buttons">
						<b-button type="is-light" @click="onBackButtonClick">戻る</b-button>
						<b-button type="is-success" :loading="isLoading" @click="onRegisterButtonClick">登録</b-button>
					</div>
				</form-field>
			</card>
		</div>
	</section>
</template>

<script>
import Card from '@/components/Card'
import FormField from '@/components/FormField'
import RadioPicker from "@/components/RadioPicker";
import DatePicker from '@/components/DatePicker'
import CheckboxGroup from '@/components/CheckboxGroup'
import moment from 'moment';

export default {
	name: "information-edit",
	components: {
		RadioPicker,
		Card,
		FormField,
		DatePicker,
		CheckboxGroup,
	},
	data() {
		return {
			isAllCheck: false,
			isLoading: false,
			id: '',
			startDate: '',
			endDate: '',
			body: '',
			checkedCustomers: [],
			customers: [],
			errors: {
				startDate: '',
				endDate: '',
				body: '',
				informationCustomers: '',
			}
		}
	},
	computed: {
	},
	mounted() {
		let subTitle = this.$route.params.informationId ? '更新' : '新規作成';
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['お知らせ管理', subTitle]
		})
		this.getData();
	},
	methods: {
		hasError: function(key) {
			return this.$utils.hasError(this.errors, key);
		},
		onCheckboxChange: function(checked) {
			this.checkedCustomers = checked;
		},
		onStartDateInput: function(date) {
			this.startDate = date;
		},
		onEndDateInput: function(date) {
			this.endDate = date;
		},
		getData: async function() {
			let loading = this.$loading.open();
			let params = this.$route.params.informationId ? '/' + this.$route.params.informationId : '';
			let ep = 'informations/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.startDate = res.data.start_date;
				this.endDate = res.data.end_date;
				this.body = res.data.body;
				this.customers = res.data.customers;
				this.checkedCustomers = res.data.checked_customers;
				this.startDate = this.startDate || moment().format('YYYY-MM-DD');
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		onRegisterButtonClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			let cc = "";
			if (this.checkedCustomers.length > 0) {
				cc = [];
				for (let i in this.checkedCustomers) {
					cc.push({ "customer_id": this.checkedCustomers[i] });
				}
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"start_date": this.startDate,
				"end_date": this.endDate,
				"body": this.body,
				"information_customers": cc,
			};
			this.$utils.log(data);

			let ep = 'informations';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'information' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		onBackButtonClick: function() {
			this.$router.go(-1);
		},
	}
}
</script>

<style scoped>
</style>
